import React, { Component, Fragment } from 'react'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Modal, Button } from 'hljd'
import { observer } from 'mobx-react'
import store from '../store'
import { REALNAME_AUTH_PATH_A } from '@constant'

@observer
export default class extends Component {
  render() {
    const { sidaVisible, unsidaVisible } = store

    return (
      <Fragment>
        <Modal
          visible={sidaVisible}
          closable={false}
          width={400}
          footer={[
            <Button key="back" onClick={store.hideModal('sidaVisible')}>
              取 消
            </Button>,
            <Button key="submit" type="primary">
              <a href={REALNAME_AUTH_PATH_A}>补全信息</a>
            </Button>,
            <Button key="submit" type="primary" onClick={store.upgradePro}>
              直接升级
            </Button>
          ]}
        >
          <p style={{ fontSize: 16, margin: 10 }}>
            <ExclamationCircleOutlined
              style={{ color: 'orange', fontSize: 16, marginRight: 10 }}
            />
            升级父级账号，建议补全营业执照信
          </p>
          <p
            style={{
              fontSize: 14,
              color: '#999',
              paddingLeft: 24,
              marginBottom: 10
            }}
          >
            如果没有补全营业执照信息，目前只能拥有不超过3个子店铺；成功补全后，无子店铺数量限制。
          </p>
        </Modal>

        <Modal
          visible={unsidaVisible}
          closable={false}
          width={400}
          footer={[
            <Button key="back" onClick={store.hideModal('unsidaVisible')}>
              取 消
            </Button>,
            <Button key="submit" type="primary">
              <a href={REALNAME_AUTH_PATH_A}>补全信息</a>
            </Button>
          ]}
        >
          <p style={{ fontSize: 16, margin: 10 }}>
            <ExclamationCircleOutlined
              style={{ color: 'orange', fontSize: 16, marginRight: 10 }}
            />
            升级父级账号，建议补全营业执照信
          </p>
          <p
            style={{
              fontSize: 14,
              color: '#999',
              paddingLeft: 24,
              marginBottom: 10
            }}
          >
            同时确保身份证与营业执照信息一致。
          </p>
        </Modal>
      </Fragment>
    )
  }
}
